import { Box, styled } from '@mui/material';

export const StackBlockContainer = styled(Box)(() => ({
  width: '100%',
  padding: '12px',

  display: 'flex',
  flexDirection: 'column',
  rowGap: '48px',

  boxSizing: 'border-box',
}));

export const StackListContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
}));
